import { wordpressImgToImgixURL } from 'Utilities';

import type { AcfImage, AcfLogos } from '../../@types/landingPages';

export const LOGO_MAX_RENDERED_HEIGHT = 40;
export const LOGO_PIXEL_DENSITY = 2;

export const toLogoList = (logos?: AcfLogos): AcfImage[] => {
  if (!logos) {
    return [];
  }

  return (Array.isArray(logos) ? logos : [logos]).filter((logo) => Boolean(logo?.url));
};

export const toLogoSrc = (url: string) => {
  const imgixUrl = wordpressImgToImgixURL(url);

  return imgixUrl !== url
    ? `${imgixUrl}&h=${LOGO_MAX_RENDERED_HEIGHT * LOGO_PIXEL_DENSITY}`
    : imgixUrl;
};
